(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            prevEl: section.querySelector(".productVisualThumbsPrev"),
            nextEl: section.querySelector(".productVisualThumbsNext"),
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingLabelInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingLabelBodyFrequencyBodyLabelInput:checked').value);
    }

    async function updateProduct() {
        // Find the active variant

        // default fallback
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").classList.add('oos');
            section.querySelector(".productATC").textContent = section.querySelector(".productATC").dataset.sold
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // if there are subscriptions, we need to update the selling plan inputs
        // as these change based on the variant
        if (product.selling_plan_groups.length > 0) {

            // find the index of the previously selected selling plan
            let inputs = section.querySelectorAll(`.productSellingLabelBodyFrequencyBodyLabelInput`);
            let selectedInputIndex = 0;
            inputs.forEach((input, index) => {
                if (input.checked) {
                    selectedInputIndex = index;
                }
            });

            let sellingPlanInputsHTML = "";

            // loop over every selling plan allocation for this active variant
            activeVariant.selling_plan_allocations.forEach((sellingPlanAllocation, index) => {
                // find the selling plan name since it's not in the object
                let sellingPlan = getSellingPlanById(sellingPlanAllocation.selling_plan_id);
                let checked = index === selectedInputIndex ? 'checked' : '';

                if(!sellingPlan) {
                    return;
                }

                sellingPlanInputsHTML += `
                <label class="productSellingLabelBodyFrequencyBodyLabel">
                    <input class="productSellingLabelBodyFrequencyBodyLabelInput" type="radio" name="${sectionID}-frequency"
                           value="${sellingPlan.id}"  ${checked}
                           data-frequency="${sellingPlan.name}">
                    <div class="productSellingLabelBodyFrequencyBodyLabelBody">
                        <div class="productSellingLabelBodyFrequencyBodyLabelBodyCircle">
                            <div class="productSellingLabelBodyFrequencyBodyLabelBodyCircleInner"></div>
                        </div>
                        <div class="productSellingLabelBodyFrequencyBodyLabelBodyTxt">
                         ${sellingPlan.name}
                        </div>
                    </div>
                </label>
            `
            });

            // insert the selling plan inputs
            section.querySelector('.productSellingLabelBodyFrequencyBody').innerHTML = sellingPlanInputsHTML;
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productSellingLabelBodyTopPriceCompare");
            const reals = section.querySelectorAll(".productSellingLabelBodyTopPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [oneTimeCompare, subCompare] = compares;
            const [oneTimeReal, subReal] = reals;

            let subscriptionPrice = activeVariant.selling_plan_allocations[0].price;
            let subscriptionCompare = activeVariant.price


            // Update subscription prices
            if (subscriptionCompare > subscriptionPrice) {
                subCompare.textContent = price(subscriptionCompare * quantity);
            }
            subReal.textContent = price(subscriptionPrice * quantity);

            // update save percent
            let savePercent = Math.round((1 - (subscriptionPrice / subscriptionCompare)) * 100);
            section.querySelector(".productSellingLabelBodyBottomPriceSave").textContent = ``;
            if (savePercent > 0) {
                let prefix = section.querySelector(".productSellingLabelBodyBottomPriceSave").dataset.prefix;
                section.querySelector(".productSellingLabelBodyBottomPriceSave").textContent = `${prefix} ${savePercent}%`;
            }

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price * quantity);
            }
            oneTimeReal.textContent = price(activeVariant.price * quantity);
        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productSellingLabelBodyTopPriceCompare");
            const realEl = section.querySelector(".productSellingLabelBodyTopPriceReal");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity);
            }
            realEl.textContent = price(activeVariant.price * quantity);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").classList.remove('oos');
            section.querySelector(".productATC").textContent = section.querySelector(".productATC").dataset.available;
        } else {
            section.querySelector(".productATC").classList.add('oos');
            section.querySelector(".productATC").textContent = section.querySelector(".productATC").dataset.sold;
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }


    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productQuantityBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productQuantityBtnValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productQuantityBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityBtnValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // OOS
        if (section.querySelector('.productATC').classList.contains("oos")) {

            // Klaviyo OOS
            Swal.fire({
                title: `Notify Me When Available`,
                input: "email",
                inputPlaceholder: "Email",
                showCancelButton: true,
                confirmButtonText: "Notify Me",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    let email = Swal.getInput().value;
                    await sendKlaviyoBackInStockRequest(email, activeVariant.id);
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                // if the user confirmed the skip, show success message and reload the page
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `Success`,
                        text: `We'll notify you when the product is back in stock.`,
                        icon: "success"
                    })
                }
            });
            return
        }

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");


        let formData = {
            items: []
        };


        formData.items.push({
            quantity: quantity,
            id: activeVariant.id
        });


        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingLabelBodyFrequencyBodyLabelInput:checked').value)
        }

        // reverse formData items
        formData.items.reverse();

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);


    /**************
     VIDEOS
     ***************/
    let videosExist = section.querySelector('.productVideos') || false;
    if (videosExist) {
        // swiper
        new Swiper(section.querySelector(".productVideos"), {
            slidesPerView: 2.2,
            spaceBetween: 20,
            breakpoints: {
                1210: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        })

        section.querySelectorAll(".productVideosBtn").forEach(function (element) {
            element.addEventListener("click", function () {

                // hide play button
                this.querySelector(".productVideosBtnPlay").classList.add("active");

                //pause all other videos if they're playing and show their play button
                section.querySelectorAll(".productVideosBtn").forEach(function (other_video) {
                    if ((other_video !== element) && (!other_video.querySelector(".productVideosBtnVid").paused)) {
                        other_video.querySelector(".productVideosBtnVid").pause();
                        other_video.querySelector(".productVideosBtnPlay").classList.remove("active");
                    }
                });

                // if this video is paused, play it, otherwise pause it (toggles play/pause)
                if (this.querySelector(".productVideosBtnVid").paused) {
                    this.querySelector(".productVideosBtnVid").play();
                    this.querySelector(".productVideosBtnPlay").classList.add("active");
                } else {
                    this.querySelector(".productVideosBtnVid").pause();
                    this.querySelector(".productVideosBtnPlay").classList.remove("active");
                }
            });
        });
    }

    /**
     * Given a selling plan id, find the master selling plan object
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            if (group.app_id === "gid://shopify/App/66228322305" || group.name === "Pre Order") {
                group.selling_plans.forEach(plan => {
                    if (plan.id === sellingPlanId) {
                        sellingPlan = plan;
                    }
                });
            }
        });
        return sellingPlan;
    }


}());